<div class="popimage">
	<img [src]="data.url" alt="">
</div>